import React, { useState } from 'react'

import Text from 'components/common/Text'
import TextButton from 'components/common/TextButton'
import TitleWithIcon from 'components/common/TitleWithIcon'
import Icon from 'components/Icon'
import InviteUsersModal from 'components/rbac-settings/InviteUsersModal'
import useAuth from 'hooks/use-auth'
import theme from 'theme'
import { Company } from 'types/api/rbac/company'

const UsersIcon = (props) => <Icon icon="users" {...props} />

interface TeamSectionProps {
  doFetch: (...args: any[]) => void
  company: Company
  isLoading: boolean
}

const TeamSection: React.FC<TeamSectionProps> = ({
  doFetch,
  company,
  isLoading,
  ...rest
}) => {
  const { hasElevatedCompanyRole, currentTeam } = useAuth()
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <div
      css={{
        zIndex: 0,
        display: 'grid',
        gap: theme.space[1],
        justifyItems: 'end'
      }}
      {...rest}
      data-testid="dashboard-team-header"
    >
      {isLoading ? (
        <Text>Fetching team...</Text>
      ) : (
        <TitleWithIcon
          as="h4"
          css={{
            justifyContent: 'flex-end'
          }}
          data-testid="dashboard-team-name"
          icon={UsersIcon}
          label={currentTeam.name}
        />
      )}
      {hasElevatedCompanyRole && (
        <div>
          <TextButton
            css={{
              display: 'inline-block',
              fontSize: theme.fontSizes[0],
              textAlign: 'right',
              fontWeight: theme.fontWeights[1]
            }}
            onClick={() => setIsModalOpen(true)}
          >
            + Invite your team members
          </TextButton>
          <InviteUsersModal
            company={company}
            data-testid="dashboard-invite-user-modal"
            doFetch={doFetch}
            isOpen={isModalOpen}
            setIsOpen={setIsModalOpen}
          />
        </div>
      )}
    </div>
  )
}

export default TeamSection
